import Grid from "@mui/material/Grid";
import { styled } from "@mui/material/styles";

import * as colors from "~/theme/colors";

import { SOCIAL_NETWORKING_LINKS_CLASSES } from "./constants";

export const SocialNetworkLinksContainer = styled(Grid)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  [theme.breakpoints.only("md")]: {
    marginBottom: theme.spacing(4),
  },
  [theme.breakpoints.up("lg")]: {
    marginBottom: theme.spacing(6.5),
  },
  [`& .${SOCIAL_NETWORKING_LINKS_CLASSES.list}`]: {
    display: "flex",
    justifyContent: "space-between",
    padding: 0,
    li: {
      width: "auto",
      padding: 0,
    },
  },
  [`& .${SOCIAL_NETWORKING_LINKS_CLASSES.link}`]: {
    color: colors.COLOR_PRIMARY_BLACK,
    display: "block",
    width: 24,
    height: 24,
  },
  [`& .${SOCIAL_NETWORKING_LINKS_CLASSES.iconWrap}`]: {
    width: 24,
    height: 24,
  },
  [`& .${SOCIAL_NETWORKING_LINKS_CLASSES.iconItem}`]: {
    width: "100%",
  },
}));
